/**
 * 插件全页路由：匹配 `/mine/plugins/:pluginId`，对声明了 manifest `route` 的已加载插件渲染全屏 `PluginIframe`，
 * 作为该插件在宿主应用内的独立「整页」入口（与侧栏链接、侧栏 `SidebarPlugins` 对应）。
 */
import { useParams } from "react-router";

import { PluginIframe } from "./plugin-iframe";
import { usePluginManager } from "./plugin-manager-context";

export function PluginRoutePage(): React.ReactElement | null {
  const { pluginId } = useParams<{ pluginId: string }>();
  const manager = usePluginManager();

  if (!pluginId || !manager) {
    return (
      <div className="flex items-center justify-center h-full text-muted-foreground">
        插件未找到
      </div>
    );
  }

  const manifest = manager.getManifest(pluginId);
  const baseUrl = manager.getBaseUrl(pluginId);

  if (!manifest?.route || !baseUrl) {
    return (
      <div className="flex items-center justify-center h-full text-muted-foreground">
        该插件没有独立页面
      </div>
    );
  }

  const src = manager.resolveUrl(baseUrl, manifest.route.path);

  return (
    <div className="w-full h-full">
      <PluginIframe
        pluginId={pluginId}
        src={src}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
}
